import React, {ReactElement, useContext, useEffect, useState} from "react";
import {ScriptLanguage, SmartTriggerProcessorInput} from "../types";
import {useAuth} from "../../../providers/AuthProvider";
import {getSmartTriggerRepositoryProcessors} from "../service/smartTriggerService";

export type SmartTriggerRepository = {
    processors: RepositoryProcessorData[],
}

export type RepositoryProcessorData = {
    id: string,
    name: string,
    description: string,
    implementation: string,
    script: ScriptLanguage,
    author: string,
    inputs: SmartTriggerProcessorInput[]

}

const SmartTriggerConfigurationContext = React.createContext<SmartTriggerRepository>({
    processors: []
});

export function SmartTriggerRepositoryProvider({children}: { children: ReactElement }) {

    const [processors, setProcessors] = useState<RepositoryProcessorData[]>([]);
    const authUser = useAuth();
    useEffect(() => {

        async function getAndSetProcessorData() {
            const processorsFromRemote = await getSmartTriggerRepositoryProcessors(authUser);
            setProcessors(processorsFromRemote)
        }

        getAndSetProcessorData();

    }, []);

    return (
        <SmartTriggerConfigurationContext.Provider value={{processors}}>
            {children}
        </SmartTriggerConfigurationContext.Provider>
    )

}

export function useSmartTriggerRepository() {
    return useContext(SmartTriggerConfigurationContext);
}
